export default {
	about: '',
	mission: '',
	vision: '',
	policy: '',
	qualityPolicy: ''
}